'use client';

import { BlogCategoryDocument } from '../../../../prismicio-types';
import {
  PostData,
  ResourceLibraryShell,
  VERTICAL_GRID_CLASS,
  VerticalResourceCard,
} from './components';

interface DefaultProps {
  categories: BlogCategoryDocument[];
  initialPosts: PostData[];
  initialHasMore: boolean;
  initialCategory?: string;
  initialSearch?: string;
  searchPlaceholder: string;
  loadMoreLabel: string;
}

/**
 * Original ResourceLibraryGrid look: three-column grid of vertical cards
 * (thumbnail on top, body below with a green-bar topic tag and underline CTA).
 */
export default function Default(props: DefaultProps) {
  return (
    <ResourceLibraryShell
      {...props}
      gridClassName={VERTICAL_GRID_CLASS}
      renderCard={(post) => <VerticalResourceCard key={post.id} post={post} />}
    />
  );
}
